<template>
  <Form :mapState="'schoolRoutesMonitors'" :typeEndPoint="this.typeEndPoint" :dataParams="this.dataParams"></Form>
</template>
<script>
import Form from '@/components/modules/base/form.vue'
export default {
  name: 'Forms',
  components: {
    Form
  },
  props: {
    typeEndPoint: { required: true },
    dataParams: {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/schoolroutes/monitors/form.vue